import { useMutation } from "react-query";
import { useTokenQuery } from "../useTokenQuery";

export function usePricesForMarkets() {
  const tokenQuery = useTokenQuery();

  return useMutation(
    "prices_for_markets",
    (action) => {
      let apiUrl = process.env.REACT_APP_API_URI.trim();

      return fetch(`${apiUrl}/operator/pricesformarkets`, {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + tokenQuery.data,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(action),
      }).then((res) => res.json());
    },
    {
      enabled: !!tokenQuery.data,
      onSuccess: (values) => {
        console.log(values);
      },
    },
  );
}
